import React, { Fragment, useMemo } from "react";
import {
	ActionMenuButton,
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuTrigger
} from "../../../components";
import { useLocale } from "../../../locales";

function VariableInsertButton(props) {
	const { t, lang } = useLocale();

	const active = useMemo(() => {
		const find = props?.items?.find(k => k.isActive());

		if (find) {
			return {
				...find
			};
		}
		const item = {
			name: props.tooltip,
			value: t("editor.variableInsert.default.tooltip"),
			isActive: () => false,
			action: () => props.editor.chain().focus().run()
		};
		return item;
	}, [t, lang, props]);

	const renderItems = (items) => {
		return items.map((item, index) => (
			<Fragment key={`value-${index}`}>
				{item.children ? (
					<div className="relative">
						<DropdownMenu>
							<DropdownMenuTrigger asChild>
								<DropdownMenuCheckboxItem>
									<div
										className="flex justify-between items-center richtext-h-full richtext-ml-1"
										style={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center"
										}}
									>
										<div>{item.name}</div>
										<div className="tox-collection__item-caret" style={{ marginLeft: "8px" }}>
											<svg width="10" height="10" focusable="false">
												<path
													d="M2.2 1.3a.8.8 0 0 1 0-1c.4-.4.9-.4 1.2 0l4.4 4.1c.3.4.3.9 0 1.2L3.4 9.8c-.3.3-.8.3-1.2 0a.8.8 0 0 1 0-1.1L6 5 2.2 1.3Z"
													fillRule="nonzero"
												></path>
											</svg>
										</div>
									</div>
								</DropdownMenuCheckboxItem>
							</DropdownMenuTrigger>
							<DropdownMenuContent
								className="richtext-w-full"
								style={{
									position: "absolute",
									left: "100%",
									top: "0",
									zIndex: 10,
								}}
								modal={false}
							>
								{renderItems(item.children)}
							</DropdownMenuContent>
						</DropdownMenu>
					</div>
				) : (
					<DropdownMenuCheckboxItem
						onClick={() => {
							item.action();
						}}
					>
						<div className="richtext-h-full richtext-ml-1">{item.name}</div>
					</DropdownMenuCheckboxItem>
				)}
			</Fragment>
		));
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger disabled={props?.disabled} asChild>
				<ActionMenuButton
					title={active?.value || props.tooltip}
					tooltip={props?.tooltip}
					disabled={props?.disabled}
					icon="MenuDown"
				/>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="richtext-w-full" modal={false}>
				{renderItems(props?.items || [])}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}

export default VariableInsertButton;
